

import React, { memo } from 'react';


function DrawerTrigger({ children, drawerRef }) {
  if (!drawerRef) {
    return typeof children === 'function' ? children({}) : children;
  }

  const instance = drawerRef.current || drawerRef;

  if (typeof children === 'function') {
    return children({ onClick: instance.toggleMinimiseState });
  }

  return React.cloneElement(children, { onClick: instance.toggleMinimiseState });
}

export default memo(DrawerTrigger);